import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { RectificatifService } from '../../divers/rectificatif/services/rectificatif/rectificatif.service';
import { Rectificatif } from './models/Rectificatif';
import { TypeLieu } from './models/TypeLieu';
import { TypeVoie } from './models/TypeVoie';
import { Annonce } from '../../common/models/annonce';
import { DiversService } from '../common/services/divers/divers.service';
import { CommonService } from '../../common/services/common/common.service';
import { DIVERS } from '../common/models/Typedivers';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class FormDiversRectificatifExtractorService {
  constructor(private formExtractorService: FormExtractorService,
    private rectificatifService: RectificatifService,
    private diversService: DiversService,
    private commonService: CommonService,
    private avisDataTransferService: AvisDataTransferService) { }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
    const rectificatif = this.avisDataTransferService.getFormData().jsonSaisieFormulaire?.ann.divers.rectificatif;

    if (stepId === 1) {
      rectificatif.avisInitial = this.rectificatifService.avisInitialService.getAvisInitial(controls);
    }

    if (stepId === 4) {
      rectificatif.infosRectif = this.rectificatifService.infosRectifService.getInfosRectif(controls, this.formExtractorService);
    }

    if (stepId === 3) {
      rectificatif.description = this.rectificatifService.descriptionService.getDescription(controls, this.formExtractorService);
      rectificatif.typeProcedure = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_procedure') == null ? '' : controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_procedure');
      rectificatif.objet = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_objet');

      rectificatif.lieuLivraison = null;
      rectificatif.lieuExecution = null;
      rectificatif.lieuExecutionLivraison = new TypeLieu();
      rectificatif.lieuExecutionLivraison.cp = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
      rectificatif.lieuExecutionLivraison.ville = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
      rectificatif.lieuExecutionLivraison.voie = new TypeVoie();
      rectificatif.lieuExecutionLivraison.voie.typevoie = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
      rectificatif.lieuExecutionLivraison.voie.nomvoie = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
      rectificatif.lieuExecutionLivraison.voie.num = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
    }

    const divers: DIVERS = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers;
    if (stepId === 2) {
      divers.organisme = this.diversService.typeAdresseCompleteObligatoireService.getTypeAdresseCompleteObligatoire(controls);
    }
    divers.initial = null;
    divers.attribution = null;
    divers.rectificatif = rectificatif;
    divers.annulation = null;

    const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
    annonce.ann.divers = divers;
		annonce.ann.mapa = null;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;

    annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
    annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
    annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		
    let avis: Avis = new Avis();

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.DIVE_RE];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_4;
    return avis;
  }
}
